import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import formPrimeiraReuniaoPadraoList from './formPrimeiraReuniaoPadraoList'



const formPrimeiraReuniaoInvestimento70List = () => {

    const formList = [...formPrimeiraReuniaoPadraoList]
    
    formList.push(
       {
        id: 140,
        descricao: 'Qual o valor de aporte mensal você planeja fazer para viabilizar a sua ' + LABEL.aposentadoria.toLowerCase() + '?',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        identificaId: HARDCODE.identificaIdPerguntaAporteAposentadoria,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 140,
    },
    )

    return formList
}
 
export default formPrimeiraReuniaoInvestimento70List